import {Paper} from "@mui/material";

const BoxLayout = (props) => {
    return (
        <Paper elevation={0} sx={{ borderRadius: "12pt",padding:props?.padding??0,boxShadow: "#4354721F 0pt 3pt 30pt" }}>{props.children}</Paper>
    );
};

export default BoxLayout;